// material-ui
import { alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import AnimateButton from 'components/@extended/AnimateButton';
import MainCard from 'components/MainCard';
import { PP_BRAND } from 'themes/theme';

// ==============================|| DRAWER CONTENT - BRAND CARD ||============================== //

export default function NavCard() {
  return (
    <MainCard
      sx={{
        m: 3,
        color: 'common.white',
        border: 'none',
        // the drawer sets whiteSpace:nowrap for nav labels — reset it so this card's copy wraps
        whiteSpace: 'normal',
        background: `linear-gradient(150deg, ${PP_BRAND.navy} 0%, #012b66 90%)`,
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          width: 160,
          height: 160,
          top: -70,
          right: -50,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${alpha(PP_BRAND.teal, 0.5)} 0%, transparent 70%)`
        }
      }}
    >
      <Stack sx={{ gap: 1.25, position: 'relative' }}>
        <Typography variant="overline" sx={{ color: alpha('#fff', 0.7) }}>
          PrivacyPal Cloud
        </Typography>
        <Typography variant="h5" sx={{ color: 'common.white', lineHeight: 1.35 }}>
          Govern every AI. Without blocking a single user.
        </Typography>
        <Typography variant="body2" sx={{ color: alpha('#fff', 0.65), mb: 0.5 }}>
          Explore deployment options and partner enablement resources.
        </Typography>
        <AnimateButton>
          <Button component={Link} href="https://privacypal.ai" target="_blank" variant="contained" color="primary" size="small">
            Learn more
          </Button>
        </AnimateButton>
      </Stack>
    </MainCard>
  );
}
